<div slimScroll class="my-3 px-5 scroll-window sen-print-offer-general">
    {{translate.getLng('ADDITIONAL_SERVICE')}}

    <mat-form-field class="d-block my-3 w-75">
        <mat-label>{{translate.getLng('ITEM_NAME')}}</mat-label>
        <input matInput>
    </mat-form-field>

    <mat-form-field class="d-block h-50 w-100">
        <mat-label>{{translate.getLng('ITEM_DESC') }}</mat-label>
        <textarea rows="18" matInput></textarea>
    </mat-form-field>

    <mat-form-field class="d-block my-3 w-25">
        <mat-label>{{translate.getLng('PRICE_NET')}} :</mat-label>
        <input mask="0000000000" matInput>
        <span matSuffix>&euro;</span>
    </mat-form-field>

</div>